export default __webpack_public_path__ + "static/media/earth.1b5b8bea.jpg";